var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 306,
    viewBox: "0 0 1440 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "footer_shape-a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF602F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.454%",
    stopColor: "#FF0085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2648B2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#footer_shape-a)",
    fillRule: "evenodd",
    d: "M720,0 C1031.41887,0 1302.14221,41.1603284 1440.00202,101.70813 L1440,306 L-9.09494702e-13,306 L-0.00102823455,101.707693 C137.859094,41.1601302 408.58188,0 720,0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterShape);
export default __webpack_public_path__ + "static/media/footer-shape.58135a2b172ed4c09ade4c92fc0fd129.svg";
export { ForwardRef as ReactComponent };